import React, { useState } from 'react';
import './ContentSection.css';

const ContentSection = ({ title, imgs, children, className }) => {
    const [isZoomed, setIsZoomed] = useState(false);
    const [currentImg, setCurrentImg] = useState(null);

    const handleImageClick = (img) => {
        setCurrentImg(img);
        setIsZoomed(true);
    };

    const handleCloseZoom = () => {
        setIsZoomed(false);
        setCurrentImg(null);
    };

    return (
        <div className={`content-section ${className}`}>
            <div className="title">
                <h1>{title}</h1>
            </div>
            <div className="image-container">
                {imgs.map((img, index) => (
                    <img
                        key={index}
                        src={img}
                        alt={`Relatório ${index + 1}`}
                        onClick={() => handleImageClick(img)}
                        className="report-image"
                    />
                ))}
            </div>
            <div className="text-content">
                {children}
            </div>

            {isZoomed && (
                <div className="zoomed-image" onClick={handleCloseZoom}>
                    <img src={currentImg} alt="Zoomed in" />
                </div>
            )}
        </div>
    );
};

export default ContentSection;
